import FilterConstants from '../../../../filter-constants';
import * as CircuitUtils from '../../../utils/circuit';

export function computeLimits(c1IdealValue, r1IdealValue, l1IdealValue) {
  let capacitorMinimumLimitMultiplier = computeCapacitorMinimumLimitMultiplier(c1IdealValue, l1IdealValue);
  let capacitorMaximumLimitMultiplier = computeCapacitorMaximumLimitMultiplier(c1IdealValue, l1IdealValue);
  let Q = (1 / r1IdealValue) * Math.sqrt(l1IdealValue / c1IdealValue);
  let c1BigLimits = computeC1BigLimits(c1IdealValue, l1IdealValue, capacitorMaximumLimitMultiplier, Q);
  let c1TinyLimits = computeC1TinyLimits(c1IdealValue, l1IdealValue, capacitorMinimumLimitMultiplier, Q);
  return {
    c1Minimum: c1TinyLimits.c1Tiny,
    c1Maximum: c1BigLimits.c1Big,
    r1Minimum: c1BigLimits.r1Tiny,
    r1Maximum: c1TinyLimits.r1Big,
    l1Minimum: c1BigLimits.l1Tiny,
    l1Maximum: c1TinyLimits.l1Big,
  };
}

export function computeGainResistorLimitMultipliers(r3IdealValue, r4IdealValue) {
  let minMultiplier = CircuitUtils.getResistorMinimumLimitMultiplier(r3IdealValue, r4IdealValue);
  let maxMultiplier = computeResistorMaximumLimitMultiplier(r3IdealValue, r4IdealValue);
  return {
    resistorMinimumLimitMultiplier: minMultiplier,
    resistorMaximumLimitMultiplier: maxMultiplier,
  };
}

function computeResistorMaximumLimitMultiplier(r3IdealValue, r4IdealValue) {
  var maxLimit = CircuitUtils.getResistorMaximumLimitMultiplier(r3IdealValue, r4IdealValue);
  var result = maxLimit;
  var rBig = r4IdealValue * maxLimit;
  if (rBig > 100e3) {
    result = (result * 100e3) / rBig;
  }

  return result;
}

function computeCapacitorMinimumLimitMultiplier(c1IdealValue, l1IdealValue) {
  var smallCapLimit = FilterConstants.Limits.CSMALL_COMP_LIMIT * 2; //20 pF
  var result = smallCapLimit / c1IdealValue;
  var l1Big = l1IdealValue / result;

  if (l1Big > FilterConstants.Limits.LBIG_COMP_LIMIT) {
    result = (l1Big / FilterConstants.Limits.LBIG_COMP_LIMIT) * result;
  }

  return result;
}

function computeCapacitorMaximumLimitMultiplier(c1IdealValue, l1IdealValue) {
  var result = FilterConstants.Limits.CBIG_COMP_LIMIT / c1IdealValue;
  var l1Tiny = l1IdealValue / result;

  if (l1Tiny < FilterConstants.Limits.LSMALL_COMP_LIMIT) {
    result = (l1Tiny / FilterConstants.Limits.LSMALL_COMP_LIMIT) * result;
  }

  return result;
}

function computeC1BigLimits(c1IdealValue, l1IdealValue, capacitorMaximumLimitMultiplier, Q) {
  var smallResLimit = FilterConstants.Limits.RSMALL_COMP_LIMIT * 20; //20 ohms
  var l1Tiny = l1IdealValue / capacitorMaximumLimitMultiplier;
  var c1Big = c1IdealValue * capacitorMaximumLimitMultiplier;
  var r1Tiny = (1 / Q) * Math.sqrt(l1Tiny / c1Big);

  if (r1Tiny < smallResLimit) {
    var multiplier = r1Tiny / smallResLimit;
    c1Big = c1Big * multiplier;
    l1Tiny = l1Tiny / multiplier;
    r1Tiny = smallResLimit;
  }

  return {
    l1Tiny: l1Tiny,
    c1Big: c1Big,
    r1Tiny: r1Tiny,
  };
}

function computeC1TinyLimits(c1IdealValue, l1IdealValue, capacitorMinimumLimitMultiplier, Q) {
  var l1Big = l1IdealValue / capacitorMinimumLimitMultiplier;
  var c1Tiny = c1IdealValue * capacitorMinimumLimitMultiplier;
  var r1Big = (1 / Q) * Math.sqrt(l1Big / c1Tiny);

  if (r1Big > FilterConstants.Limits.RBIG_COMP_LIMIT) {
    var multiplier = r1Big / FilterConstants.Limits.RBIG_COMP_LIMIT;
    l1Big = l1Big / multiplier;
    c1Tiny = c1Tiny * multiplier;
    r1Big = FilterConstants.Limits.RBIG_COMP_LIMIT;
  }

  return {
    l1Big: l1Big,
    c1Tiny: c1Tiny,
    r1Big: r1Big,
  };
}
